import { FormattedShopifyCollection } from '@portal/types/shopify/product.formatted.types';
import { ShopifyCartPayload } from '@portal/types/shopify/cart.types';
import { StoreEnum } from '@portal/schema/storeCode';
import { isDoubleSubscription } from '@portal/shared/utils/check/isDoubleSubscription';
import { getShopifyStringId } from '@portal/shared/utils/shopify/getShopifyStringId';
import { isCoreProduct } from '@portal/shared/utils/shopify/isCoreProduct';
import { CHECKOUT_TYPE } from '@portal/state/cart/constants';
import {
  getCoreProductQuantityMetafield,
  getCoreProductSellingPlanIdMetafield
} from '@portal/shared/utils/shop/bundle/metafields';
import cookies from 'js-cookie';

export const constructBundleCartPayload = (
  store: StoreEnum,
  bundle: FormattedShopifyCollection,
  utmString: string,
  customerTags?: string[] | null
) => {
  const cartPayload = {
    lines: bundle.products.map((product) => {
      const useCoreProductLineCalcuations = isCoreProduct(product);
      const { id: variantId, sellingPlanAllocations } = product.variants[0];

      let quantity = 1; // by default all products has qty x1
      if (useCoreProductLineCalcuations) {
        const quantityMetaValue = getCoreProductQuantityMetafield(bundle)?.value;
        const customCoreProductQuantity = quantityMetaValue ? Number(quantityMetaValue) : undefined;

        if (customCoreProductQuantity) {
          quantity = customCoreProductQuantity; // if bundle has core_product_quantity metadata, use it
        } else if (isDoubleSubscription(store, getShopifyStringId(variantId) as string)) {
          quantity = 2; // default set all double sub variantId products to qty x2
        }
      }

      return {
        merchandiseId: variantId,
        quantity,
        ...(useCoreProductLineCalcuations && {
          sellingPlanId:
            getCoreProductSellingPlanIdMetafield(bundle)?.value || sellingPlanAllocations[0].id,
          attributes: [
            {
              key: '__shop_subscriptions',
              value: 'true'
            },
            { key: '__isBundleItem', value: 'true' } // temporary flag for bundle identification in cart
          ]
        })
      };
    })
  } as ShopifyCartPayload;

  cartPayload.attributes = [
    { key: 'checkoutOriginUrl', value: window.location.href },
    { key: CHECKOUT_TYPE.key, value: CHECKOUT_TYPE.PLP }
  ];

  const socialLadderTrackCode = cookies.get('sl-track-purchase');
  if (socialLadderTrackCode) {
    cartPayload.attributes.push({
      key: 'social_ladder.tracking_cookie',
      value: socialLadderTrackCode
    });
  }

  if (utmString) {
    cartPayload.attributes.push({
      key: 'utm-data',
      value: utmString
    });
  }

  if (customerTags?.length) {
    cartPayload.attributes.push({
      key: 'customerTags',
      value: JSON.stringify(customerTags)
    });
  }

  return cartPayload;
};
